import { OperationListComponent } from './pages/operation/operation-list/operation-list.component';
import { OperationConfirmationComponent } from './pages/operation/operation-confirmation/operation-confirmation.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes, TitleStrategy } from '@angular/router';

import { OperationTransferenceComponent } from './pages/operation/operation-transference/operation-transference.component';
import { CharacteristicConsultComponent } from './pages/register/characteristic-consult/characteristic-consult.component';
import { CreditRegisterComponent } from './pages/register/credit-register/credit-register.component';
import { RegisterConfirmationComponent } from './pages/register/register-confirmation/register-confirmation.component';
import { AccessDeniedComponent } from './shared/access-denied/access-denied.component';
import { OperationWithdrawalComponent } from './pages/operation/operation-withdrawal/operation-withdrawal.component';
import { PageTitleHelper } from './helpers/PageTitleHelper';
import { OAuthComponent } from './pages/authentication/oauth/oauth.component';
import { PositionConsultComponent } from './pages/position/position-consult/position-consult.component';
import { LoggedinGuard } from './services/auth/security/loggedin.guard';
import { Perfil } from './services/auth/perfil.enum';
import { ProjectRegisterComponent } from './pages/projects-repository/register/project/project-register.component';
import { ProjectConsultComponent } from './pages/projects-repository/consult/project/project-consult.component';
import { ProjectRegisterConfirmationComponent } from './pages/projects-repository/register-confirmation/project/project-register-confirmation.component';
import { EmissionRegisterComponent } from './pages/emission-credit/register/emission/emission-register.component';
import { EmissionConsultComponent } from './pages/emission-credit/consult/emission/emission-consult.component';
import { EmissionVisualizationComponent } from './pages/emission-credit/visualization/emission/emission-visualization.component';
import { ProjectRegisterVisualizationComponent } from './pages/projects-repository/register-visualization/project/project-register-visualization.component';
import { ProjectRegisterValidationComponent } from './pages/projects-repository/register-validation/project/project-register-validation.component';
import { HomeComponent } from './pages/home/home.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'pagina-inicial',
    pathMatch: 'full',
    title: 'Página inicial'
  },
  {
    path: 'pagina-inicial',
    component: HomeComponent,
    canActivate: [ LoggedinGuard ],
    data: {
      hideAppHeader: true,
    },
    title: 'Página inicial'
  },
  {
    path: 'registro-projeto',
    component: ProjectRegisterComponent,
    canActivate:[ LoggedinGuard ],
    data: {
      perfil: Perfil.CAR_PSA_REGISTRA_PROJETO,
      hideAppHeader: true
    },
    title: 'Registro de Projeto'
  },
  {
    path: 'registro-projeto/:id',
    component: ProjectRegisterComponent,
    canActivate:[ LoggedinGuard ],
    data: {
      perfil: Perfil.CAR_PSA_REGISTRA_PROJETO,
      hideAppHeader: true
    },
    title: 'Registro de Projeto'
  },
  {
    path: 'consulta-projeto',
    component: ProjectConsultComponent,
    canActivate:[ LoggedinGuard ],
    data: {
      perfil: Perfil.CAR_PSA_CONSULTA_PROJETO,
      hideAppHeader: true
    },
    title: 'Repositório de Projetos - Consulta'
  },
  {
    path: 'registro-projeto-confirmacao/:id',
    component: ProjectRegisterConfirmationComponent,
    canActivate:[ LoggedinGuard ],
    data: {
      perfil: Perfil.CAR_PSA_AUDITA_PROJETO
    },
    title: 'Registro de Projeto - Confirmação de Registro'
  },
  {
    path: 'visualizacao-projeto-credito/:id',
    component: ProjectRegisterVisualizationComponent,
    canActivate:[ LoggedinGuard ],
    data: {
      perfil: [ Perfil.CAR_PSA_AUDITA_PROJETO, Perfil.CAR_PSA_CONSULTA_PROJETO ]
    },
    title: 'Registro de Projeto - Visualização'
  },
  {
    path: 'validacao-projeto-credito',
    component: ProjectRegisterValidationComponent,
    canActivate:[ LoggedinGuard ],
    data: {
      perfil: Perfil.CAR_PSA_AUDITA_PROJETO,
      hideAppHeader: true
    },
    title: 'Registro de Projeto - Validação'
  },
  {
    path: 'registro-emissao-credito',
    component: EmissionRegisterComponent,
    canActivate:[ LoggedinGuard ],
    data: {
      perfil: Perfil.CAR_PSA_REGISTRA_PROJETO,
      hideAppHeader: true
    },
    title: 'Emissão de Crédito - Registro'
  },
  {
    path: 'consulta-emissao-credito',
    component: EmissionConsultComponent,
    canActivate:[ LoggedinGuard ],
    data: {
      perfil: Perfil.CAR_PSA_CONSULTA_PROJETO
    },
    title: 'Emissão de Crédito - Consulta'
  },
  {
    path: 'confirma-emissao-credito',
    component: EmissionConsultComponent,
    canActivate:[ LoggedinGuard ],
    data: {
      perfil: Perfil.CAR_PSA_AUDITA_PROJETO
    },
    title: 'Emissão de Crédito - Verificação'
  },
  {
    path: 'visualizacao-emissao-credito/:emissionId',
    component: EmissionVisualizationComponent,
    canActivate:[ LoggedinGuard ],
    data: {
      perfil: [Perfil.CAR_PSA_AUDITA_PROJETO,Perfil.CAR_PSA_CONSULTA_PROJETO]
    },
    title: 'Emissão de Crédito - Visualização'
  },
  {
    path: 'registro-credito',
    component: CreditRegisterComponent,
    canActivate:[ LoggedinGuard ],
    data: {
      perfil: Perfil.CAR_REGISTRO_CREDITO_DE_CARBONO,
      hideAppHeader: true
    },
    title: 'Registro'

  },
  {
    path: 'consulta-caracteristicas',
    component: CharacteristicConsultComponent,
    canActivate: [ LoggedinGuard ],
    data: {
      perfil: Perfil.CAR_CONSULTA_CREDITO_DE_CARBONO,
      hideAppHeader: true,
    },
    title: 'Consulta de registro de crédito'
  },
  {
    path: 'registro-confirmacao',
    component: RegisterConfirmationComponent,
    canActivate: [ LoggedinGuard ],
    data: {
      perfil: Perfil.CAR_CONFIRMACAO_DE_REGISTRO_CREDITO_DE_CARBONO,
    },
    title: 'Confirmação de Registro'
  },
  {
    path: 'operacao-transferencia',
    component: OperationTransferenceComponent,
    canActivate: [ LoggedinGuard ],
    data: {
      perfil: Perfil.CAR_TRANSFERENCIA_CREDITO_DE_CARBONO,
      hideAppHeader: true
    },
    title: 'Transferir Créditos de Carbono'
  },
  {
    path: 'operacao-retirada',
    component: OperationWithdrawalComponent,
    canActivate: [ LoggedinGuard ],
    data: {
      perfil: Perfil.CAR_TRANSFERENCIA_CREDITO_DE_CARBONO,
      hideAppHeader: true
    },
    title: 'Retirada'
  },
  {
    path: 'consulta-operacoes',
    component: OperationListComponent,
    canActivate: [ LoggedinGuard ],
    data: {
      perfil: Perfil.CAR_CONSULTA_OPERACOES_CREDITO_DE_CARBONO,
      hideAppHeader: true
    },
    title: 'Consulta de Operações'
  },
  {
    path: 'operacoes-confirmacao',
    component: OperationConfirmationComponent,
    canActivate: [ LoggedinGuard ],
    data: {
      perfil: Perfil.CAR_CONFIRMA_OPERACOES_CREDITO_DE_CARBONO,
      hideAppHeader: true,
    },
    title: 'Confirmar Operação'
  },
  {
    path: 'consulta-posicao',
    component: PositionConsultComponent,
    canActivate: [ LoggedinGuard ],
    data:{
      perfil: Perfil.CAR_CONSULTA_OPERACOES_POSICAO_CREDITO_DE_CARBONO,
      hideAppHeader: true,
    },
    title: 'Consulta de Posição'
  },
  {
    path: 'acesso-negado',
    component: AccessDeniedComponent,
    title: 'Acesso Negado'
  },
  {
    path: 'oauth',
    component: OAuthComponent,
    title: 'Autenticação'
  },
  {
    path: '**',
    redirectTo: 'pagina-inicial',
    pathMatch: 'full',
    title: 'Página inicial'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [
    { provide: TitleStrategy, useClass: PageTitleHelper }
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
